import { Component, OnInit } from "@angular/core";
import { FormField } from "../../../interfaces/form-field.model";
import { faPrint, faEraser } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { ChequeIssueMemoService } from "src/app/services/autopac-reports/cheque-issue-memo.service";

@Component({
  selector: "cheque-issue-memo",
  templateUrl: "./cheque-issue-memo.component.html",
  styleUrls: ["./cheque-issue-memo.component.css"],
})
export class ChequeIssueMemoComponent implements OnInit {
  faPrint = faPrint;
  faEraser = faEraser;

  lockBtn = true;

  form!: FormField[];

  constructor(
    private notifier: NotifierService,
    private ChequeIssueMemoService: ChequeIssueMemoService,
  ) {}

  updateFields(event: any): void {
    this.form = event.fields;
    if (
      this.getFieldValue("FromDate") &&
      this.getFieldValue("ToDate")
    ) {
      this.lockBtn = false;
    } else {
      this.lockBtn = true;
    }
  }

  ngOnInit() {
    this.setUpFormFields();
  }

  private setUpFormFields(): void {
    this.form = [
      {
        type: "date",
        id: "InvoiceDate",
        label: "Invoice Date (dd/mm/yyyy)",
      },
      {
        type: "date",
        id: "ChequeDate",
        label: "Cheque Date (dd/mm/yyyy)",
      },
      {
        type: "const",
        id: "AmountWord",
        label: "Amount Word",
      },
      {
        type: "checkbox",
        id: "type",
        options: [
          {
            value: "Printer",
            display: "Check Printer",
          },
          {
            value: "Cheque",
            display: "Display Cheque",
          },
          {
            value: "Paper",
            display: "Check Sufficient Paper",
          },
        ],
      },
      {
        type: "text",
        lock: true,
        id: "Locations",
        label: "Locations",
      },
      {
        type: "select",
        id: "Format",
        label: "Select Format",
        options: [
          {
            value: "pdf",
            display: "PDF",
          },
          {
            value: "excel",
            display: "EXCEL",
          },
          {
            value: "both",
            display: "BOTH",
          },
        ],
        value: "pdf",
      },
    ];
  }

  printStatus(): void {
    const searchData = this.populateSearchBody();
    this.ChequeIssueMemoService.GetDataAccountReceivableAging(
      searchData,
    ).subscribe({
      next: (response) => {
        if (this.getFieldValue("Format") == "pdf") {
          window.open(response.body.Name, "_blank");
        } else if (this.getFieldValue("Format") == "excel") {
          window.open(response.body.Value, "_blank");
        } else if (this.getFieldValue("Format") == "both") {
          window.open(response.body.Value, "_blank");
          window.open(response.body.Name, "_blank");
        }
      },
      error: (error) => {
        console.log(error);
        this.handleError("Error getting data", error);
      },
    });
  }

  private populateSearchBody(): any {
    return {
      FromDate: formatDate(
        this.getFieldValue("FromDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
      ToDate: formatDate(
        this.getFieldValue("ToDate"),
        "dd/MM/yyyy",
        "en-US",
      ),
    };
  }

  private getFieldValue(id: string, index?: number): any {
    const field = this.form.find((f) => f.id === id);
    return index !== undefined ? field?.value[index] : field?.value;
  }

  private handleError(message: string, error: any): void {
    console.error(message, error);
    this.notifier.notify("error", message);
  }
}
